import styled from 'styled-components';

export const Cont = styled.div`
    width: 40%;
    margin-bottom: 2rem;
`;

export const Container = styled.div`
    width: 100%;
    display: flex;
    background: #ffffff;
    border: 1px solid #c4c4c4;
    box-shadow: var(--box-shadow);
    border-radius: 8px;
    position: relative;
    overflow-x: hidden;
    flex-direction: column;
    padding: var(--padding-base);

    > header {
        display: flex;
        justify-content: space-between;

        > main {
            display: flex;
            justify-content: flex-end;
            flex-direction: column;
            align-items: flex-end;

            > p {
                font-size: 0.7rem;
            }
        }
    }

    > main {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 1rem;

        > * {
            margin-bottom: var(--padding-base);
        }

        > header {
            display: flex;
            flex-direction: column;
            width: 100%;

            > img {
                width: 100%;
                border-radius: var(--border-radius);
                background-color: #eee;
            }
        }
    }

    > footer {
        > * {
            margin-bottom: 0.5rem;
        }

        &:last-of-type {
            margin-bottom: 0;
        }
    }
`;

export const Title = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    > h1 {
        font-size: 1.3rem;
        color: var(--color-text);
    }
`;

export const Description = styled.div`
    > div {
        margin-top: 2rem;

        > h3 {
            font-size: 0.9rem;
            color: #979797;
            font-weight: 500;
            margin-top: 0;
            padding-bottom: 0.8rem;
        }

        > p {
            font-size: 0.8rem;
            color: #111;
        }

        &:first-of-type {
            margin-top: 1rem;
        }
    }
`;

export const BlankImage = styled.div`
    width: 100%;
    padding-bottom: 56.25%;
    background-color: #ddd;
    border-radius: var(--border-radius);
`;

export const Actions = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 24px;

    > div {
        display: flex;
        align-items: center;
        font-size: 14px;
    }
`;

export const Spacer = styled.div`
    flex-grow: 1;
`;

export const HeaderTitle = styled.div`
    font-family: 'Myriad Pro';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 130%;
    margin-top: 0.32rem;
    margin-bottom: 24px;
`;
